import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import logo from '../images/logo.png';

class Contact extends Component {
	render() {
		return (
			<div>
				<header>
					<figure>
          				<Link to='/'><img className="img-responsive" src={logo} alt="Gnabagam Logo" /></Link>
      				</figure>   
			    </header>

			    <section class="alternative-pages">
			      <div className="container">
			        <h2>Frequently Asked Questions</h2>
			        <hr/>

			        <h4>What can I do if a video is not working?</h4>
			        <p>Please indicate the year, as well as the titles of both the song and movie and report it to support@gnabagam.com. In some instances, it is because the video is restricted to certain countries as per Youtube's policies for which there is very little we can do. Otherwise, we will try and find a better link!</p>
				<br/>
			        <h4>Can I expect more albums from past years?</h4>
			        <p>Absolutely, we add content regularly so keep checking in!</p>
				<br/>
			        <h4>This site is missing a song I like!</h4>
			        <p>Again, please indicate the year, as well as the titles of both the song and movie and report it to gnabagam.com@gmail.com. Include a Youtube link if you can and we'll post the song as soon as possible.</p>
			      </div>
			    </section>
			</div>
		)
	}
}

export default Contact;


// WEBPACK FOOTER //
// ./src/components/Contact.js